export const canvas = document.getElementById("canvas");
export const ctx = canvas.getContext("2d");

const car = new Image();
car.src = "https://res.cloudinary.com/dhjxj05jc/image/upload/c_scale,h_117,q_10,w_225/v1518731332/car_eq7txv.png";
const lawnMower = new Image();
lawnMower.src = "https://res.cloudinary.com/dhjxj05jc/image/upload/c_scale,q_10,w_163/v1518732334/mower_dsbonl.png";
const worker = new Image();
worker.src = "https://res.cloudinary.com/dhjxj05jc/image/upload/c_scale,q_10,w_170/v1518732388/worker_flaraj.png";
const dozer = new Image();
dozer.src = "https://res.cloudinary.com/dhjxj05jc/image/upload/c_scale,q_10,w_593/v1518732443/dozer_oxglol.png";
const fireball = new Image();
fireball.src = "https://res.cloudinary.com/dhjxj05jc/image/upload/c_scale,q_10,w_178/v1518732497/firebal_n4hx7x.png";
const tennisBoy = new Image();
tennisBoy.src = "https://res.cloudinary.com/dhjxj05jc/image/upload/c_scale,q_10,w_260/v1518732545/tennis_boy_qzgtsr.png";
const cat = new Image();
cat.src = 'https://res.cloudinary.com/dhjxj05jc/image/upload/c_scale,q_10,w_288/v1518732609/Catbert_iduw3o.png';
const catBoss = new Image();
catBoss.src = 'https://res.cloudinary.com/dhjxj05jc/image/upload/c_scale,q_10,w_400/v1518732654/catboss_zfmu5k.png';

export default class MovingObject {

  constructor(movingObjectX, movingObjectY, movingObjectWidth, movingObjectHeight) {
    this.movingObjectX = movingObjectX;
    this.movingObjectY = movingObjectY;
    this.movingObjectWidth = movingObjectWidth;
    this.movingObjectHeight = movingObjectHeight;
  }


  drawCat() {
    ctx.drawImage(cat, this.movingObjectX, this.movingObjectY, this.movingObjectWidth, this.movingObjectHeight);
  }

  drawCars() {
    ctx.drawImage(car, this.movingObjectX, this.movingObjectY, this.movingObjectWidth, this.movingObjectHeight);
    if (this.movingObjectX < canvas.width + 100) {
      this.movingObjectX  = this.movingObjectX  + 3;
    } else {
      this.movingObjectX = -25;
    }
  }

  drawMower() {
    ctx.drawImage(lawnMower, this.movingObjectX, this.movingObjectY, this.movingObjectWidth, this.movingObjectHeight);
  }

  drawDozer() {
    ctx.drawImage(dozer, this.movingObjectX, this.movingObjectY, this.movingObjectWidth, this.movingObjectHeight);
    if (this.movingObjectX < canvas.width + 100) {
      this.movingObjectX  = this.movingObjectX  + 2;
    } else {
      this.movingObjectX = -110;
    }
  }

  drawWorkers() {
    ctx.drawImage(worker, this.movingObjectX, this.movingObjectY, this.movingObjectWidth, this.movingObjectHeight);
    if (this.movingObjectY < canvas.height + 100) {
      this.movingObjectY  = this.movingObjectY  + 3;
    } else {
      this.movingObjectY = 25;
    }
  }

  drawFireballs() {
    ctx.drawImage(fireball, this.movingObjectX, this.movingObjectY, this.movingObjectWidth, this.movingObjectHeight);
    if (this.movingObjectX < canvas.width + 100) {
      this.movingObjectX  = this.movingObjectX  + 3;
    } else {
      this.movingObjectX = -25;
    }
  }


  drawTennisBoy() {
    ctx.drawImage(tennisBoy, this.movingObjectX, this.movingObjectY, this.movingObjectWidth, this.movingObjectHeight);
    if (this.movingObjectY < canvas.height + 100) {
      this.movingObjectX  = this.movingObjectX  - 2;
      this.movingObjectY = this.movingObjectY + 2;
    } else {
      this.movingObjectY = -25;
      this.movingObjectX = 725;
    }
  }

  drawCatBoss() {
    ctx.drawImage(catBoss, this.movingObjectX, this.movingObjectY, this.movingObjectWidth, this.movingObjectHeight);
  }
}



// WEBPACK FOOTER //
// ./lib/moving_objects.js